import React from "react";

const Intro: React.FC = () => {
  return (
    <section className="section-container" id="skills_intro">
      <div className="top-content">
        <div className="description">
          <h1 className="section-title">My Skills</h1>
          <p>
            In 2014 I began my path in web development and chose at the time to
            focus on one Javascript Framework, React. I now consider myself a
            React specialist and most of my skills reflect that.
          </p>
          <p>
            While engineering is a strong passion for me, design is equally so.
            I do not have as much professional training and experience in design
            but it is an aspect of my work that has always come very natural to
            me. I believe a lot of it is due to my extensive involvment in the
            arts when I was young and it has been a key difference maker in my
            career.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Intro;
